import {
    ADD_AMBASSADOR,
    GET_AMBASSADOR
    
  } from "core/redux/actions";
  import { ActionModel } from "core/model/ActionModel";
  import {IAmbassador} from 'core/model/ambassador'

  interface Ambassador {
    ambassadors: IAmbassador[];
  }

  const INIT_STATE: Ambassador = {ambassadors: []};

  export default (state = INIT_STATE, action: ActionModel) => {
    switch (action.type) {
      case GET_AMBASSADOR:
      return { ...state, ambassadors: action.payLoad};
      case ADD_AMBASSADOR:
      let tempAmbassador = [...state.ambassadors];
      tempAmbassador.push(action.payLoad);
      return { ...state, ambassadors: tempAmbassador };
      default:
        return state;
    }
  }